import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import RutasModal from "./RutasModal";
import NavBar from "../../Common/NavBar";
import buildRequestData from "./requestDataRutas";
import { RutasCard } from "./RutasCard";
import { EditarElemento, GuardarElementos } from "../../Hooks/CRUDHooks";
import { rutasDeshabilitar, rutasURL, rutasxEmpresaPURL } from "../../API/apiurls";
import { useGlobalState } from "../../Context/GlobalStateContext";
import { PaginacionUtils } from "../../Hooks/PaginacionUtils";
import "../../Styles/Rutas.css";
import useErrorHandler from "../../Hooks/useErrorHandler";

export function Rutas() {
  const { userData } = useGlobalState();
  const { empresaId, empresaNombre } = userData;

  // Visibility state for the modal
  const [show, setShow] = useState(false);

  const [datos, setDatos] = useState([]);
  const [datosEdit, setDatosEdit] = useState(null);

  const [pageNumber, setPageNumber] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const { errorMessage, handleErrorResponse } = useErrorHandler();

  const Listar = async (page) => {
    try {
      const response = await axios.get(`${rutasxEmpresaPURL}1/${empresaId}?pageNumber=${page}`);
      setDatos(response.data.content);
      setTotalPages(response.data.totalPages);
      setCurrentPage(response.data.number + 0);
    } catch (error) {
      console.error("Error al listar", error);
    }
  };

  // useEffect hook to trigger data loading when 'pageNumber' changes
  useEffect(() => {
    Listar(pageNumber);
  }, [pageNumber]);

  // Function to close the modal and reset data
  const handleCerrar = () => {
    setShow(false);
    setDatosEdit(null);
  };

  // Function to display the modal and load data for editing
  const datosAEditar = (camion) => {
    setDatosEdit(camion);
    setShow(true);
  };

  // Function to save new data and handle the response
  const handleGuardar = (datosFormulario) => {
    const requestData = buildRequestData(datosFormulario, empresaId);
    GuardarElementos(`${rutasURL}`, requestData, datos, setDatos)
      .then(() => {
        setShow(false);
        Listar(pageNumber);
      })
      .catch(handleErrorResponse);
  };

  // Function to edit data and handle the response
  const handleEditar = async (dato) => {
    console.log(dato);
    try {
      const requestData = buildRequestData(dato, empresaId);
      await EditarElemento(`${rutasURL}/${dato.id}`, requestData);
      setShow(false);
      Listar(pageNumber);
    } catch (error) {
      console.log("ds");
      handleErrorResponse(error);
    }
  };

  // Function to perform logical deletion (disable) of data and handle the response
  const handleEliminar = (id) => {
    Swal.fire({
      title: `¿Esta seguro de eliminar esta ruta? ${id}`,
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar ruta",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        EditarElemento(`${rutasDeshabilitar}${id}/0`)
          .then(() => {
            const nuevosDatos = datos.filter((ruta) => ruta.id !== id);
            setDatos(nuevosDatos);
            Swal.fire("Eliminado", "La ruta ha sido eliminada", "success");
          })
          .catch(handleErrorResponse);
      }
    });
  };

  return (
    <div className="rutas-page">
      <NavBar />
      <section className="rutas-header">
        <div className="rutas-header-copy">
          <h1 className="rutas-header-title">Rutas de la empresa</h1>
          <p className="rutas-header-subtitle">
            Gestiona las rutas registradas para {empresaNombre || "tu empresa"}.
          </p>
        </div>
        <div className="rutas-header-meta">
          <div className="rutas-header-chip">
            <span>Empresa</span>
            <strong>{empresaNombre || "Cargando..."}</strong>
          </div>
          <div className="rutas-header-chip">
            <span>Mostrando</span>
            <strong>{datos?.length ?? 0} rutas</strong>
          </div>
        </div>
      </section>

      <div className="rutas-actions">
        <Button className="rutas-create-button" onClick={() => setShow(true)}>
          Crear nueva ruta
        </Button>
      </div>

      <section className="camionesMenu-contenedor rutas-shell">
        <div className="rutas-toolbar">
          <h2 className="rutas-toolbar-title">Listado de rutas</h2>
          <p className="rutas-toolbar-text">Pagina {currentPage + 1} de {Math.max(totalPages, 1)}</p>
        </div>

        <div className="rutas-grid">
          {datos &&
            datos.map((ruta, index) => (
              <RutasCard
                key={ruta.id}
                index={index}
                ruta={ruta}
                empresaNombre={empresaNombre}
                datosAEditar={datosAEditar}
                handleEliminar={handleEliminar}
              />
            ))}
        </div>

        {(datos === undefined || datos.length === 0) && (
          <div className="rutas-empty-state">
            <h3>No hay rutas registradas</h3>
            <p>Su empresa no tiene rutas, por favor agregue una.</p>
          </div>
        )}

        <div className="rutas-pagination">
          <PaginacionUtils setPageNumber={setPageNumber} setCurrentPage={setCurrentPage} currentPage={currentPage} totalPages={totalPages} />
        </div>
      </section>
      <RutasModal mostrar={show} cerrar={() => handleCerrar()} guardar={handleGuardar} datosaeditar={datosEdit} editar={handleEditar} />
    </div>
  );
}
